import { useTranslation } from "react-i18next";
import Tab from "components/tab";
import CommunicationsList from "./CommunicationsList";

type Props = {
  id: string;
  emailCount?: string;
  textCount?: string;
};

export default function CustomerCommunicationsTab({
  id,
  emailCount,
  textCount,
}: Props) {
  const { t } = useTranslation();
  const tBase = "views.customer.containers.communications";
  const tr = (key: string) => t(`${tBase}.${key}`);

  const subTabs = {
    emails: {
      tab: tr("Emails"),
      count: emailCount,
      content: <CommunicationsList customerId={id} channel="email" />,
    },
    texts: {
      tab: tr("Texts"),
      count: textCount,
      content: <CommunicationsList customerId={id} channel="sms" />,
    },
  };

  return <Tab data={subTabs} defaultTab="emails" />;
}
